import { ProjectFooterResponse } from '@/types/service-response'

export class ProjectDetailFooter {
  public constructor (
    readonly Netto: number, //double
    readonly Steuer: number, //double
    readonly Total: number, //double
    readonly Marge: number, //double
    readonly ProjectId: number
  ) {}

  static createFromResponse (responseData: ProjectFooterResponse): ProjectDetailFooter {
    return new ProjectDetailFooter(
      responseData.Netto,
      responseData.Steuer,
      responseData.Total,
      responseData.Marge,
      responseData.ProjectId)
  }
}
